module.exports = __webpack_public_path__ + "img/6.e3609eee.png";